import { request } from "./httpClient";

function getBaseUrl(prefixKey) {
    const prefix = window.appConfig && window.appConfig[prefixKey];
    return process.env.REACT_APP_API_URL + prefix;
}

const actionStrategies = {
    customerDetails: (customerId) => {
        const url = new URL(`${getBaseUrl("customerDetailPrefix")}${customerId}`);
        return {
            url,
            method: "GET",
            timeoutKey: "getTimeout",
        };
    },
    joinCustomer: (idp_id, joinData = {}) => {
        const url = new URL(`${getBaseUrl("joinCustomerPrefix")}${idp_id}`);
        if (joinData.customer_id) {
            url.searchParams.set("customer_id", joinData.customer_id);
        }
        return {
            url,
            method: "PATCH",
            timeoutKey: "universalTimeout",
        };
    },
    sendConfig: (site_id) => {
        const url = new URL(`${getBaseUrl("sendConfigPrefix")}${site_id}`);
        return {
            url,
            method: "POST",
            timeoutKey: "universalTimeout",
        };
    },
    updateAllDevices: (version_id) => {
        const url = new URL(`${getBaseUrl("edgeVersionsPrefix")}update_devices/${version_id}`);
        return {
            url,
            method: "POST",
            timeoutKey: "universalTimeout",
        };
    },
    updateSingleDevice: (site_id, version_id) => {
        const url = new URL(`${getBaseUrl("edgeVersionsPrefix")}update_device/${site_id}/${version_id}`);
        return {
            url,
            method: "POST",
            timeoutKey: "universalTimeout",
        };
    },
};

function masterActionCall(actionKey, ...params) {
    const strategy = actionStrategies[actionKey];
    if (!strategy) {
        throw new Error(`No strategy found for ${actionKey}`);
    }
    const { url, method, timeoutKey, body } = strategy(...params);
    const timeout = window.appConfig && window.appConfig[timeoutKey];
    const options = { method };
    if (body !== undefined) {
        options.body = typeof body === "string" ? body : JSON.stringify(body);
    }
    return request(url.toString(), options, timeout);
}

export const customerDetailsApi = {
    get(customerId) {
        return masterActionCall("customerDetails", customerId);
    }
};

export const joinCustomerApi = {
    patch(idp_id, joinData) {
        return masterActionCall("joinCustomer", idp_id, joinData);
    }
};

export const sendConfigApi = {
    post(site_id) {
        return masterActionCall("sendConfig", site_id);
    }
};

export const updateDevicesApi = {
  post(versionId, siteId = null) {
    if (siteId) {
      return masterActionCall("updateSingleDevice", siteId, versionId);
    } else {
      return masterActionCall("updateAllDevices", versionId);
    }
  }
};